var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgVisaLogo = function SvgVisaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M10.362 13.645H6.784L4.1 3.172c-.128-.482-.398-.908-.796-1.108A11.5 11.5 0 0 0 .025.955V.552H5.79c.796 0 1.392.606 1.492 1.31l1.392 7.554L12.25.552h3.479zm7.355 0h-3.38L17.12.552h3.38zm7.154-9.466c.1-.705.696-1.108 1.392-1.108 1.094-.102 2.286.1 3.28.604l.597-2.82A8.4 8.4 0 0 0 27.059.25c-3.28 0-5.666 1.814-5.666 4.33 0 1.915 1.69 2.92 2.883 3.526 1.291.604 1.788 1.008 1.689 1.612 0 .905-.994 1.309-1.987 1.309-1.193 0-2.387-.302-3.479-.807l-.596 2.82c1.193.504 2.484.706 3.677.706 3.678.1 5.963-1.712 5.963-4.432 0-3.424-4.672-3.625-4.672-5.135m16.498 9.466L38.686.552h-2.882c-.597 0-1.193.403-1.392 1.007l-4.968 12.086h3.478l.694-1.913h4.275l.397 1.913zm-5.068-9.567.993 4.934h-2.782z",
    clipRule: "evenodd"
  })));
};
var Memo = /*#__PURE__*/memo(SvgVisaLogo);
export default Memo;